// import { isNavigationAgentRoute } from './isNavigationAgentRoute';
import { lazy, Suspense, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// const FloatingAgent = lazy(() => import('@/components/mobile/FloatingAgent'));
const AiCopilotWidget = lazy(() =>
  import('@/features/AiChat').then((module) => ({ default: module.AiChat }))
);

const overlayHiddenRoutes = [
  '/forgot-password',
  '/login',
  '/register',
  '/register/organization',
  '/reset-password'
];

const overlayRoutePrefixes = [
  '/finance',
  '/profile',
  '/shipments',
  '/warehouses'
];

const isKnownOverlayRoute = (pathname: string): boolean => {
  if (pathname === '/') return true;

  return overlayRoutePrefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
};

const isOverlayHiddenRoute = (pathname: string): boolean => {
  return overlayHiddenRoutes.includes(pathname);
};

const DeferredOverlays = () => {
  const location = useLocation();
  const [isReady, setIsReady] = useState(false);
  const isOverlayAvailable = isKnownOverlayRoute(location.pathname);
  const isOverlayHidden = isOverlayHiddenRoute(location.pathname);
  // const shouldRenderFloatingAgent = !isNavigationAgentRoute(location.pathname);
  const shouldRenderOverlays = isOverlayAvailable && !isOverlayHidden;

  useEffect(() => {
    if (!shouldRenderOverlays) {
      setIsReady(false);
      return;
    }

    let cancelled = false;
    let idleId: number | null = null;
    let timeoutId: number | null = null;

    const enableOverlays = () => {
      if (cancelled) return;
      requestAnimationFrame(() => {
        if (!cancelled) setIsReady(true);
      });
    };

    type IdleWindow = Window & {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
      cancelIdleCallback?: (id: number) => void;
    };
    const w = window as IdleWindow;
    if (typeof w.requestIdleCallback === 'function') {
      idleId = w.requestIdleCallback(enableOverlays, { timeout: 1200 });
    } else {
      timeoutId = window.setTimeout(enableOverlays, 400);
    }

    return () => {
      cancelled = true;
      if (idleId !== null && typeof w.cancelIdleCallback === 'function') {
        w.cancelIdleCallback(idleId);
      }
      if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [shouldRenderOverlays]);

  if (!isReady || !shouldRenderOverlays) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      {/* {shouldRenderFloatingAgent && <FloatingAgent size="mini" />} */}
      <AiCopilotWidget />
    </Suspense>
  );
};

export default DeferredOverlays;